import ActionTypes from '../constants/actionTypes';
import sendEmailRequest from '../utils/sendEmailRequest';
import EMAIL_CODES from '../constants/emailCodes';

function update(response) {
  return {
    type: ActionTypes.UPDATE[EMAIL_CODES.PRICING_REQUEST],
    payload: response.data
  };
}

function broadcastError(err) {
  return {
    type: ActionTypes.FAILED2FETCH[EMAIL_CODES.PRICING_REQUEST],
    payload: err
  };
}

function request() {
  return {
    type: ActionTypes.REQUEST[EMAIL_CODES.PRICING_REQUEST]
  };
}

export default data => {
  return function(dispatch) {
    dispatch(request());

    return sendEmailRequest(data)
      .then(response => {
        if (response.data && response.data.success) {
          dispatch(update(response));
        } else {
          dispatch(broadcastError(response.data.message));
        }
      })
      .catch(error => {
        dispatch(broadcastError(error));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/send_pricing_request.js